module.exports = __webpack_public_path__ + "static/media/sidewalk-pdx.81264148.png";